// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__JI4Hg","rotate":"styles_rotate__IOpIe","rotate-reverse":"styles_rotate-reverse__f8QHJ"};